import { useEffect } from "react";
import Intercom from "@intercom/messenger-js-sdk";
import api from "src/store/features/api";
import { INTERCOM_APP_ID } from "src/utils/constants";

export default function IntercomComponent() {
  const { data: intercomJwtRes } = api.useGetIntercomJwtQuery();
  const intercom_user_jwt = intercomJwtRes?.userHash;
  useEffect(() => {
    if (intercom_user_jwt) {
      Intercom({
        app_id: INTERCOM_APP_ID,
        intercom_user_jwt,
      });
    }
  }, [intercom_user_jwt]);

  return <></>;
}
